<div class="animated fadeIn">
<h3>Admin Panel</h3>
                <br/>

<div class="row">

    <div class="col-lg-12">
        <div class="card">
            
            <div class="card-body" style="min-height: 600px;">
             <h4 class="box-title">File Audit Details</h4>
             <!--<a class="float-right rtbtn btn btn-primary" style="margin-top: -35px;" (click)="logout()">Logout</a>-->
              <br/>
                <table id="bootstrap-data-table" class="table table-striped table-bordered dataTable no-footer" role="grid" aria-describedby="bootstrap-data-table_info">
                                            <thead>
                                                <tr role="row">
                                                    <th >Date</th>
                                                    <th >Requested By</th>
                                                    <th >Actioned By</th>
                                                    <th >Activity</th>
                                                    
                                                    <th >Note</th>
                                                    <th >Comments</th>
                                                    
                                                    
                                                </tr>
                                            </thead>
                                            <tbody> 
                                            <tr role="row" class="odd" >
                                               <td>2019-02-04 </td>
                                               <td>analyst@test.com</td>
                                               <td>admin@test.com</td>
                                               <td>Delete Request</td>
                                               <td>Delete Request Approve</td>
                                               <td>--</td>
                                            </tr> 
                                            <!--<tr role="row" class="odd" *ngIf="haveData">
                                                <td colspan="5"> NO DATA FOUND
                                               </td>
                                            </tr> -->
                                            
                                        </tbody>
                                        </table>
            </div>
        </div>
       


</div>
</div><!-- .animated -->


<div class="animated fadeIn">
<h3>Admin Panel</h3>
                <br/>

<div class="row">

    <div class="col-lg-12">
        <div class="card">
            
            <div class="card-body" style="min-height: 600px;">
             <h4 class="box-title">File Audit </h4>
             <!--<a class="float-right rtbtn btn btn-primary" style="margin-top: -35px;" (click)="logout()">Logout</a>-->
              <br/>
                <table id="bootstrap-data-table" class="table table-striped table-bordered dataTable no-footer" role="grid" aria-describedby="bootstrap-data-table_info">
                                            <thead>
                                                <tr role="row">
                                                    <th >File Type</th>
                                                    <th >Year</th>
                                                    <th >Quarter</th>
                                                    <th >Month</th>
                                                    
                                                    <th >Company</th>
                                                    <th >Company ID</th>
                                                    <th >Last Updated On</th>
                                                    <th >Action</th>
                                                    
                                                </tr>
                                            </thead>
                                            <tbody> 
                                            <tr role="row" class="odd" >
                                               <td>Form </td>
                                               <td>2019-2020</td>
                                               <td>Q1</td>
                                               <td>N/A</td>
                                               <td>2019-02-04</td>
                                               <td>Acko General Insurance Ltd</td>
                                               <td>ACK</td>
                                               <td><a  style="margin-left: 5px;"  class="btn"><i class="fa fa-eye"></i></a></td>
                                            </tr> 
                                            <!--<tr role="row" class="odd" *ngIf="haveData">
                                                <td colspan="5"> NO DATA FOUND
                                               </td>
                                            </tr> -->
                                            
                                        </tbody>
                                        </table>
            </div>
        </div>
       


</div>
</div><!-- .animated -->

